export const PASSWORD_REQUIREMENT_MESSAGE =
  "Use at least 8 characters with uppercase, lowercase, a number, and a symbol.";

const PASSWORD_RULES = [
  { id: "length", label: "At least 8 characters", test: (value) => value.length >= 8 },
  { id: "lower", label: "One lowercase letter", test: (value) => /[a-z]/.test(value) },
  { id: "upper", label: "One uppercase letter", test: (value) => /[A-Z]/.test(value) },
  { id: "number", label: "One number", test: (value) => /\d/.test(value) },
  { id: "symbol", label: "One special character", test: (value) => /[^A-Za-z0-9]/.test(value) },
];

const STRENGTH_LABELS = ["Too weak", "Weak", "Fair", "Good", "Strong", "Strong"];

export function evaluatePassword(password) {
  const value = String(password || "");
  const checks = PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    passed: rule.test(value),
  }));
  const score = checks.filter((check) => check.passed).length;

  return {
    score,
    label: value ? STRENGTH_LABELS[score] : "",
    meter: value ? Math.min(4, Math.max(1, score === 5 ? 4 : score === 4 ? 4 : score)) : 0,
    tone: !value ? "" : score >= 5 ? "strong" : score >= 4 ? "good" : score >= 3 ? "fair" : "weak",
    passed: Boolean(value) && score === PASSWORD_RULES.length,
    checks,
    message: PASSWORD_REQUIREMENT_MESSAGE,
  };
}
